export const treeJoinList = async (nodes: any) => {
    const nodeMap:any = {};   // 哈希表存储所有节点
    const roots:any = [];     // 存储根节点
    
    // 第一次遍历：初始化节点并创建映射
    nodes.forEach((node:any) => {
        nodeMap[node.menuId] = { ...node, children: [] }; // 深拷贝避免污染原数据
    });
    
    // 第二次遍历：建立父子关系
    nodes.forEach((node:any) => {
        const parentNode = nodeMap[node.parentId];
        if (parentNode) {
            parentNode.children.push(nodeMap[node.menuId]); // 将当前节点加入父节点的 router
        } else {
        roots.push(nodeMap[node.menuId]); // 没有父节点则视为根节点
        }
    });
    
    return roots; // 返回所有根节点组成的树
}

export const treeJoinList2 = async (nodes: any) => {
    const nodeMap:any = {};   // 哈希表存储所有节点
    const roots:any = [];     // 存储根节点
    
    // 第一次遍历：初始化节点并创建映射
    nodes.forEach((node:any) => {
        nodeMap[node.menuId] = { ...node, children: [] }; // 深拷贝避免污染原数据
    });
    
    // 第二次遍历：建立父子关系
    nodes.forEach((node:any) => {
        const parentNode = nodeMap[node.parentId];
        if (parentNode) {
            nodeMap[node.menuId].path = parentNode.path + '/' + nodeMap[node.menuId].path
            parentNode.children.push(nodeMap[node.menuId]); // 将当前节点加入父节点的 router
        } else {
        roots.push(nodeMap[node.menuId]); // 没有父节点则视为根节点
        }
    });
    
    return roots; // 返回所有根节点组成的树
}

export const flattenTree = (routes:any[]) => {
    let flatRoutes:any = [];
 
    function traverse(route:any) {
        // 将当前路由对象加入结果数组
        flatRoutes.push(route);
        // 如果当前路由有嵌套的 routes，递归处理
        if (route.routes) {
            route.routes.forEach((childRoute:any) => traverse(childRoute));
        }
    }
    
    // 遍历原始路由数组
    routes.forEach(route => traverse(route));
    
    return flatRoutes;
}
